import axios, { AxiosError } from 'axios';
import { parseAxiosError } from '../common/constant';
import { BASEURL, LDAP_API_TOKEN } from './const';


/* HTTP Request Interceptor to add headers on all API calls */
axios.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('id');
        config.headers['x-api-key'] = token
        config.headers['apikey'] = LDAP_API_TOKEN
        return config;
    },
    error => {
        Promise.reject(error);
    }
)


/* HTTP Response Interceptor to redirect to not found page when 401 HTTP Code Received */
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error)
    }
)


/* get the internal token via public UUID */
export const getInternalToken = async (tokenId: string): Promise<any> => {
    try {               
        const response = await axios.get(`${BASEURL}/auth/getInternalToken?id=${tokenId}`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

/* to get the configuration object via the internal UUID */
export const getConfig = async (internalId: string): Promise<any> => {
    try {
        const response = await axios.get(`${BASEURL}/auth/getConfig?internalUUID=${internalId}`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const authenticateLDAP = async (data: object): Promise<any> => {
    try {
        const response = await axios.post(`${BASEURL}/auth/ldap`, data);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const authenticateGoogleToken = async (data: object): Promise<any> => {
    try {
        const response = await axios.post(`${BASEURL}/auth/google`, data);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}